import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { Chapter } from '../../../models/chapter';
import { ChapterService } from '../../../services/chapter.service';
import { CommunicationService } from '../../../services/communication.service';
import { PageChangedEvent } from '../../../utils/events/page-changed-event';
import { ApplicationStateService } from '../../../services/application-state.service';
import { PageService } from '../../../services/page.service';
import { UpperCasePipe } from '@angular/common';

@Component({
    selector: 'app-chapter-switcher',
    templateUrl: './chapter-switcher.component.html',
    styleUrls: ['./chapter-switcher.component.scss'],
    standalone: true,
    imports: [
        UpperCasePipe
    ]
})
export class ChapterSwitcherComponent implements OnInit, OnDestroy {

    @Input() previous: boolean;
    @Input() next: boolean;
    chapter: Chapter;
    nameToShow: string;

    hierarchy: Array<number | string>;
    showChapterNames: boolean;

    private subscription: Subscription;

    constructor(private chapterService: ChapterService,
                private communicationService: CommunicationService,
                private applicationStateService: ApplicationStateService,
                private pageService: PageService) {

        this.subscription = this.communicationService.chapterTurnConfirmed$.subscribe(event => {

            if (this.next) {
                this.chapter = event.nextChapter;
            }

            if (this.previous) {
                this.chapter = event.previousChapter;
            }
            this.getHierarchy();
            this.getNameToShow();
        });
    }

    ngOnInit(): void {
        this.fetchChapter();
        this.showChapterNames = this.applicationStateService.bookConfig.chaptersOrderEnabled;
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    turnToPage(): void {
        this.pageService.addToHistory(this.applicationStateService.currentIndex);
        const pageturnEvent = new PageChangedEvent();
        pageturnEvent.moveToPage = this.chapter.index;
        this.communicationService.announcePageTurn(pageturnEvent);
    }

    private fetchChapter(): void {

        if (this.previous) {
            this.chapterService.getPreviousChapter().then(chapter => {
                this.chapter = chapter;
                this.getNameToShow();
                this.getHierarchy();
            });
        }

        if (this.next) {
            this.chapterService.getNextChapter().then(chapter => {
                this.chapter = chapter;
                this.getNameToShow();
                this.getHierarchy();
            });
        }
    }

    private getHierarchy(): void {
        this.chapterService.getChapterHierarchyFromChapter(this.chapter).then(result => {
            this.hierarchy = result;
        });

    }

    private getNameToShow(): void {

        if (!this.chapter) {
            this.nameToShow = undefined;

            return;
        }

        const maxChars = 50;
        this.nameToShow = this.chapter.title;

        if (this.nameToShow.length > maxChars) {
            this.nameToShow = this.nameToShow.substr(0, maxChars);
            this.nameToShow += '...';
        }

    }

}
